module.exports = __webpack_public_path__ + "img/ellipse-texture-s.1267577c.svg";